import AppLoadingShell from "./AppLoadingShell";

/**
 * Full-screen loader for auth bootstrap and fatal setup states.
 * @param {{ message?: string; variant?: "splash" | "route" }} props
 */
export default function LoadingScreen({
  message = "Starting TheRallyAlly…",
  variant = "splash",
}) {
  return <AppLoadingShell variant={variant} message={message} aria-label="Loading app" />;
}
